import React from 'react';
import { motion } from 'framer-motion';
import { Award, CheckCircle } from 'lucide-react';
export function CertificationSection() {
  return <section className="py-20 bg-[#EBF4FA] overflow-hidden" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-22">
          {/* Left Column: Image */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative h-full min-h-[400px] rounded-2xl overflow-hidden shadow-lg order-2 lg:order-1" data-id="element-23">
            <img src="https://images.unsplash.com/photo-1581092162384-8987c1d64718?w=600&q=80" alt="Safety professional in PPE" className="w-full h-full object-cover" data-id="element-24" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2E78B6]/60 to-transparent" data-id="element-25"></div>
            <div className="absolute bottom-6 left-6 text-white" data-id="element-26">
              <p className="font-bold text-lg" data-id="element-27">Veiligheid eerst</p>
              <p className="text-sm opacity-90" data-id="element-28">
                Geen compromissen op de werkvloer
              </p>
            </div>
          </motion.div>

          {/* Right Column: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-29">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2E78B6] mb-6" data-id="element-30">
              Veiligheid en kwaliteit staan centraal
            </h2>
            <p className="text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-31">
              Wij werken volgens de hoogste normen op het gebied van veiligheid,
              gezondheid en milieu. Gedurende het volledige proces worden
              medewerkers continu gewezen op hun verantwoordelijkheid binnen
              KVG&M.
            </p>

            <div className="flex items-center gap-4 text-[#2E78B6] font-semibold text-lg bg-white/50 p-4 rounded-lg border border-[#2E78B6]/10 mb-8" data-id="element-32">
              <CheckCircle className="w-6 h-6 text-[#F57C00]" data-id="element-33" />
              <span data-id="element-34">
                Veilig werken is voor ons geen formaliteit, maar een kernwaarde.
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-35">
              {[{
              title: 'VCA**',
              desc: 'Veiligheid Checklist Aannemers'
            }, {
              title: 'BRL 6000',
              desc: 'Kwaliteitsborging'
            }, {
              title: 'ISO 14001',
              desc: 'Milieumanagement'
            }].map((cert, index) => <motion.div key={index} whileHover={{
              y: -5
            }} className="bg-white p-4 rounded-xl shadow-md border-t-4 border-[#F57C00] text-center" data-id="element-36">
                  <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-37">
                    <Award className="w-5 h-5 text-[#2E78B6]" data-id="element-38" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-39">
                    {cert.title}
                  </h3>
                  <p className="text-xs text-gray-500" data-id="element-40">{cert.desc}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}